/** @format */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinBy',
  standalone: true,
  pure: true,
})
export class JoinByPipe implements PipeTransform {
  transform<T extends Record<string, unknown>>(
    list: T[] | null | undefined,
    key: keyof { [K in keyof T as T[K] extends string ? K : never]: T[K] },
    delimiter = ' | ',
  ): string {
    if (!Array.isArray(list) || !key) return '';
    return list
      .map((item) => {
        const value = item?.[key];
        return typeof value === 'string' ? String(value) : '';
      })
      .filter(Boolean)
      .join(delimiter);
  }
}
